import { TreeItem, TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { CMSRootTreeItem } from '../components/CMSRootTreeItem.js'
import { SimpleTreeItemData } from '../types.js'

export const CMS_INDEX = 'cms'

export function createCMSRootTreeItem(
  { $t }: I18nShape,
  {
    children,
  }: {
    children: TreeItemIndex[]
  },
): TreeItem<SimpleTreeItemData> {
  return {
    index: CMS_INDEX,
    isFolder: true,
    data: {
      type: 'simple',
      title: $t({
        id: 'Generics.CMS',
        defaultMessage: 'CMS',
      }) as string,
      render: () => <CMSRootTreeItem />,
    },
    children,
  }
}
